/*
 * newsbot - forked from autobrr
 */

import { Link } from "@tanstack/react-router";
import { LinkIcon } from "@heroicons/react/24/solid";

import { classNames } from "@utils";

export type StatsRoute = "/stories" | "/settings/batches" | "/settings/feeds";

export interface StatsItemProps {
  name: string;
  value?: number | string;
  to?: StatsRoute;
  color?: "default" | "green" | "yellow" | "red" | "blue";
}

const colorClasses = {
  default: "text-gray-900 dark:text-gray-200",
  green: "text-green-600 dark:text-green-400",
  yellow: "text-yellow-600 dark:text-yellow-400",
  red: "text-red-600 dark:text-red-400",
  blue: "text-blue-600 dark:text-blue-400",
};

export const StatsItem = ({ name, value, to, color = "default" }: StatsItemProps) => {
  const displayValue = typeof value === "number" ? value.toLocaleString() : value;
  const inner = (
    <>
      <dt>
        <div className="flex items-center text-xs font-medium text-gray-500 transition-colors duration-200 ease-in-out group-hover:text-gray-600 dark:group-hover:text-gray-400">
          <p className="truncate pb-0.5">{name}</p>
          {to && <LinkIcon className="ml-1 h-3 w-3" aria-hidden="true" />}
        </div>
      </dt>
      <dd className={classNames("flex items-baseline text-2xl font-extrabold", colorClasses[color])}>
        <p>{displayValue ?? "—"}</p>
      </dd>
    </>
  );

  if (to) {
    return (
      <Link
        className="group relative cursor-pointer overflow-hidden rounded-lg bg-white px-4 py-3 shadow-lg transition-shadow duration-200 ease-in-out hover:shadow-xl dark:bg-gray-800"
        to={to}
      >
        {inner}
      </Link>
    );
  }

  return (
    <div className="group relative overflow-hidden rounded-lg bg-white px-4 py-3 shadow-lg dark:bg-gray-800">
      {inner}
    </div>
  );
};
